import AsyncStorage from "@react-native-async-storage/async-storage";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import type { PersistQueryClientOptions } from "@tanstack/react-query-persist-client";
import { STORAGE_KEY } from "~/lib/constants";
import { GUEST_COUNTERS_QUERY_KEY } from "~/state/counters";

const asyncStoragePersister = createAsyncStoragePersister({
  storage: AsyncStorage,
  key: `${STORAGE_KEY}:query-cache`,
  // A guest's counters are the only thing this app persists, written one
  // deliberate edit at a time, so a short throttle trades a few extra
  // AsyncStorage writes for not losing an edit to a reload seconds later.
  throttleTime: 100,
});

/**
 * Only the guest counters are persisted. Authenticated data is always
 * refetched from the API (the app is online-only once signed in), so caching it
 * to disk would just risk showing stale data after a sign-out / sign-in as
 * someone else.
 */
export const persistOptions: Omit<PersistQueryClientOptions, "queryClient"> = {
  persister: asyncStoragePersister,
  // The guest counters have no server copy — this persisted entry IS the
  // data, not a cache of it — so it must never be aged out.
  maxAge: Infinity,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) =>
      query.queryKey[0] === GUEST_COUNTERS_QUERY_KEY[0],
  },
};
